import type { Verification } from '../../../AppPageBlock/graphql/hirer-types.generated';

import type { VerificationsQuery } from './VerificationsQuery.hirer.generated';

export const getVerificationsData = (
  data?: VerificationsQuery,
): {
  verifiedIdentity?: Verification;
  workHistory: Verification[];
  education: Verification[];
  licences: Verification[];
  rightToWork: Verification[];
} => {
  const applicationResult =
    data?.applicationByAdcentreProspectId.__typename ===
    'ApplicationResponseSuccess'
      ? data.applicationByAdcentreProspectId.result
      : null;

  if (data?.applicationByAdcentreProspectId.__typename === 'ResponseError') {
    throw new Error(data.applicationByAdcentreProspectId.error);
  }

  const profileResult =
    applicationResult?.profile.__typename ===
    'ApplicationProfileResponseSuccess'
      ? applicationResult.profile.result
      : null;

  if (applicationResult?.profile.__typename === 'ResponseError') {
    throw new Error(applicationResult.profile.error);
  }

  const verificationsResult =
    profileResult?.verifications.__typename ===
    'ApplicationProfileVerificationsSuccess'
      ? profileResult.verifications.result
      : null;

  if (profileResult?.verifications.__typename === 'ResponseError') {
    throw new Error(profileResult.verifications.error);
  }

  return {
    verifiedIdentity: verificationsResult?.verifiedIdentity || undefined,
    workHistory: verificationsResult?.workHistory || [],
    education: verificationsResult?.education || [],
    licences: verificationsResult?.licences || [],
    rightToWork: verificationsResult?.rightToWork || [],
  };
};
